import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const loginTime = localStorage.getItem('loginTime');
    const now = new Date().getTime();

    if (!isLoggedIn || now - loginTime > SESSION_TIMEOUT) {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('loginTime');
      navigate('/login');
    } else {
      // Refresh session timestamp on activity
      const activityListener = () => {
        localStorage.setItem('loginTime', new Date().getTime());
      };

      window.addEventListener('click', activityListener);
      window.addEventListener('keypress', activityListener);

      return () => {
        window.removeEventListener('click', activityListener);
        window.removeEventListener('keypress', activityListener);
      };
    }
  }, [navigate]);

  return <>{children}</>;
}
